import './index.scss'

const Logo = () => {
	return (
	<span class="logo">./*</span>
	);
}

export default Logo

